import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    ManangementActionsUnion,
    ManagementActionTypes
} from '@core/actions/management.action';
import { providerManagements } from '@app/models/providerManagements';
import { comparerByAlphabet } from '@app/comparers';

export interface State extends EntityState<providerManagements> {
  loading: boolean;
  loaded: boolean;
  selectedId: number;
  isBusy: boolean;
}

export const adapter: EntityAdapter<providerManagements> = createEntityAdapter<providerManagements>({
  selectId: (management: providerManagements) => management.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  selectedId: null,
  isBusy: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ManangementActionsUnion
) {
  switch (action.type) {
    case ManagementActionTypes.Load:
      return { ...state, loading: true, isBusy: true };

    case ManagementActionTypes.LoadFail:
      return { ...state, loading: false, isBusy: false};

    case ManagementActionTypes.LoadSuccess:
      if(action && action.mode && action.mode === 'managementView'){
        return adapter.addAll(action.management, {
          ...state,
          loading: false,
          loaded: true,
          isBusy: false
        });
      }else{
        return {
          ...state,
          loading: false,
          loaded: true,
          isBusy: false
        };
      }
      

    case ManagementActionTypes.Select:
      return { ...state, selectedId: action.id };

    case ManagementActionTypes.Delete:
      return adapter.removeOne(action.id, state);

    case ManagementActionTypes.Create:
      return adapter.addOne(action.data, state);

    case ManagementActionTypes.Update:
      return adapter.updateOne({ id: action.id, changes: action.data }, state);

    case ManagementActionTypes.AddResponsable:
      return { ...state, loading: true, isBusy: true };

    case ManagementActionTypes.AddResponsableSuccess:
    case ManagementActionTypes.DeleteResponsableSuccess:
      return adapter.upsertMany(action.data, {
      ...state,
      loading: false,
      loaded: true,
      isBusy: false
    });

    case ManagementActionTypes.AddResponsableFail:
    case ManagementActionTypes.DeleteResponsableFail:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false
      }

    default:
      return state;
  }
}
export const getState = createFeatureSelector<State>('managements');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const getAll = createSelector(
    getState,
    selectAll
);

export const getAllManagement = createSelector(
    getState,
    getAll
);

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSelectedId = (state: State) => state.selectedId;


export const getIsBusy = createSelector(
  getState,
  (state: State) => state.isBusy
);
